import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const ACCESS_TOKEN_PROVIDER = new InjectionToken<AccessTokenProvider>('accessTokenProvider');

export interface AccessTokenProvider {
    readonly accessTokenOnce$: Observable<string>;
    readonly accessTokenChanged$?: Observable<string>;
}
